<template>
    <div>
        <!--添加商品-->
        <Card :bordered="false" dis-hover>
            <p slot="title">添加商品</p>
            <Form  :label-width="100" inline>
                <FormItem label="商品名称：" >
                    <Input class="edit-input" placeholder="不填时，默认为无商品名" v-model.trim="sendData.name"></Input>
                </FormItem>
                <FormItem label="商品货号：">
                    <Input class="edit-input" :maxlength="32"  placeholder="货号为必填项(最多32个字符)" v-model.trim="sendData.goodscode"></Input><span> (必填项)</span>
                </FormItem>
                <br>
                <FormItem label="采购价："  v-if="isroule">
                     <InputNumber :min="0" class="edit-input" :max="99999999"  placeholder="不填时，默认为零" v-model.trim="sendData.cprice"></InputNumber>
                </FormItem>
                <FormItem label="批发价：">
                    <InputNumber :min="0" class="edit-input" :max="99999999"  placeholder="请输入批发价"  v-model.trim="sendData.pprice"></InputNumber>
                </FormItem>
                <FormItem label="零售价：">
                    <InputNumber :min="0" class="edit-input" :max="99999999"  placeholder="请输入采购价"  v-model.trim="sendData.lprice"></InputNumber>
                </FormItem>
                <br>
                <FormItem label="分类：">
                    <Input class="edit-input" disabled placeholder="无" v-model.trim="showTypeTrue"></Input>
                    <Button type="default" style="margin-left: 15px" @click="openDrawer(1,'选择分类')">选择</Button>
                </FormItem>
                <br>
                <FormItem label="性别：">
                    <RadioGroup v-model="sendData.sex">
                        <Radio label="1">
                            <span>男</span>
                        </Radio>
                        <Radio label="0" style="margin: 0 20px">
                            <span>女</span>
                        </Radio>
                        <Radio label="2">
                            <span>通用</span>
                        </Radio>
                    </RadioGroup>
                </FormItem>
                <br>
                <FormItem label="商品规格：">
                    <Tag type="border" color="primary"  v-for="(item,index) in sendData.sizeList" :key="index">{{item.name}}</Tag>
                    <Tag color="primary"><Icon type="md-add"  @click="openDrawer(3,'新增规格')" size="20"/></Tag>
                </FormItem>

                <br>
                <FormItem label="商品颜色：">
                    <Tag type="border" color="primary" v-for="(item,index) in sendData.colorList" @click.native="openDrawer(2,'添加颜色')" :key="index">{{item.name}}</Tag>
                    <Tag color="primary"><Icon type="md-add"  @click="openDrawer(2,'添加颜色')"  size="20"/></Tag>
                </FormItem>
                <br>
                <FormItem label="条码设置：" >
                    <span style="color: #2d8cf0" v-if="$store.state.AddCommodity.barCodeSetting!=''">已设置</span>
                    <!--<Button type="default" style="margin-left: 15px" v-if="prveStatus=='edit' || prveStatus=='copy'" @click="openDrawer(4,'条码设置')">设置</Button>-->
                    <Button type="default" style="margin-left: 15px" :disabled="iscreatebarcode==1"   @click="openDrawer(6,'条码设置')">设置</Button>
                </FormItem>
                <FormItem label="库存设置：">
                    <span style="color: #2d8cf0" v-if="$store.state.AddCommodity.total!=0">已设置</span>
                    <Button type="default" style="margin-left: 15px"  @click="openDrawer(5,'库存设置')">设置</Button>
                </FormItem><br>
                <FormItem label="库存预警：">
                    <InputNumber :min="1" v-model="sendData.warning" style="width: 200px" ></InputNumber>
                </FormItem>
                <br>
                <FormItem label="添加图片：" style="margin-bottom: 0">
                    <!--图片展示列表-->
                    <div class="demo-upload-list" v-for="(item,index) in uploadList" :key="index">
                        <!--删除or查看按钮-->
                        <template v-if="item.status === 'finished'">
                            <Fy-Img
                                    class="img"
                                    :ImgSrc="item.url | filtImg(item.url)"
                            ></Fy-Img>
                            <div class="demo-upload-list-cover">
                                <Icon type="ios-eye-outline"  @click.native="handleView(index)"></Icon>
                                <Icon type="ios-trash-outline"  @click.native="handleRemove(item)"></Icon>
                            </div>
                        </template>
                        <!--加载进度条-->
                        <template v-else>
                            <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                        </template>
                    </div>
                    <!--上传按钮组件-->
                    <Upload
                            v-if="isShowUpload"
                             ref="upload"
                            :show-upload-list="false"
                            :on-success="handleSuccess"
                            :before-upload="beforeUpload"

                            :format="['jpg','jpeg','png']"
                            :max-size="5120"
                            :on-format-error="handleFormatError"
                            :on-exceeded-size="handleMaxSize"
                            multiple
                            type="drag"
                            :action="actionImgUrl"
                            style="display: inline-block;width:100px;">
                        <div style="width: 100px;height:100px;line-height: 100px;">
                            <Icon type="md-add" size="30" />
                        </div>
                    </Upload>
                    <!--弹框照片-->
                    <Modal title="查看照片" v-model="visible" transfer>
                        <Carousel v-if="visible" v-model="isShowNumImg" :height="auto">
                            <CarouselItem  v-for="(item,index) in uploadList" :key="index">
                                    <img style="display: block;margin: auto;" :src="item.url|filtImg(item.url)" />
                            </CarouselItem>
                        </Carousel>
                    </Modal>
                </FormItem>
                <br>
                <FormItem>
                    <span style="color: #afafaf">(最多添加8张，第一张为主图)</span>
                </FormItem><br>
                <FormItem>
                    <Button type="primary" :loading="submitLoading" @click="addGoods()">
                        <span v-if="!submitLoading">添加</span>
                        <span v-else>添加中</span>
                    </Button>
                </FormItem>
            </Form>
        </Card>

        <!--抽屉弹框-->
        <Drawer :title="contentName" width="500" :closable="true" v-model="$store.state.AddCommodity.allDrawer" class="allDrawer">
            <!--分类-->
            <template v-if="showIndex==1">
                <strong>你的选择类别： <span style="color: #F00;">{{typeGoodsName}}<Icon type="ios-arrow-forward" v-if="isShowRight" />{{selZidsName}}</span></strong>
                <Divider />
                <Row class="select-fatherTitle">
                    <Col span="12">
                        <div class="fatherTitle">
                            <Col span="16" style="padding-left: 10px">
                               默认
                            </Col>
                            <Col span="8">
                                <ButtonGroup size="small"   class="delBtn">
                                    <Button type="primary" title="选择" @click="defaultNull"><Icon type="md-checkmark"/></Button>
                                </ButtonGroup>
                            </Col>
                        </div>
                        <div v-if="goodsClassify[0].id!=null" class="fatherTitle" :class="{'active':isClickNum==index}" v-for="(item,index) in goodsClassify" :key="index">
                            <Row>
                                <Col span="16" style="padding-left: 10px">
                                    {{item.name}}
                                </Col>
                                <Col span="8">
                                    <ButtonGroup size="small" shape="circle"  class="delBtn">
                                        <Button type="primary" title="选择" @click="selFid(item,index)"><Icon type="md-checkmark"/></Button>
                                        <Button type="warning" title="删除" @click="delTypeItem(item.id,0)"><Icon type="ios-trash-outline"/></Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </div>
                        <div class="fatherTitle"  style="text-align: center" @click="addTypeItem(0)"> <Icon type="ios-add-circle-outline" class="major" size="26"/> 新增分类</div>
                    </Col>
                    <Col span="12"  v-if="goodsClassify[0].id!=null"  class="select-fatherTitle" style="padding:0 ">
                        <aside class="aside-childer">
                            <div v-for="(m,n) in goodsClassify[isClickNum].type_itmes" :key="n">
                                <Row>
                                    <Col span="14" style="padding-left: 10px">
                                        {{m.name}}
                                    </Col>
                                    <Col span="10">
                                        <ButtonGroup size="small" shape="circle"  class="delBtn">
                                            <Button type="primary" title="选择" @click="selZid(m)"><Icon type="md-checkmark"/></Button>
                                            <Button type="warning" title="删除"  @click="delTypeItem(m.id,1)"><Icon type="ios-trash-outline"/></Button>
                                        </ButtonGroup>
                                    </Col>
                                </Row>
                            </div>
                            <div class="fatherTitle active" style="text-align: center"  @click="addTypeItem(1)"> <Icon type="ios-add-circle-outline" class="major" size="26" /> 新增子类</div>
                        </aside>
                    </Col>
                </Row>
            </template>

            <!--商品颜色-->
            <template v-if="showIndex==2">
                <color-list></color-list>
            </template>
            <!--选择规格-->
            <template v-if="showIndex==3">
                <size-list></size-list>
            </template>
            <!--条码设置-->
            <template v-if="showIndex==4">
                <bar-code></bar-code>
            </template>
            <!--库存设置-->
            <template v-if="showIndex==5">
                <stock-set></stock-set>
            </template>
            <!--添加条码-->
            <template v-if="showIndex==6">
                <add-bar-code></add-bar-code>
            </template>
        </Drawer>

        <!--第二弹框-->
        <Drawer title="供应商列表" width="350" :closable="false" v-model="$store.state.AddCommodity.childerDrawer">
            <Input search enter-button="搜索" v-model="SupplierName"  />
            <CellGroup>
                <Cell v-for="(item,index) in SupplierList" :key="index"> <div @click="selectSupOK(item)"><Icon type="md-person" /> {{item.name}}</div> </Cell>
            </CellGroup>
        </Drawer>
    </div>
</template>
<script>
    import ColorList from "../../components/Common/ColorList";
    import SizeList from "../../components/Common/SizeList";
    import BarCode from "../../components/Common/BarCode";
    import StockSet from "../../components/Common/StockSet";
    import addBarCode from "../../components/Common/addBarCode";
    export default {
        components: {ColorList,SizeList,BarCode,StockSet,addBarCode},
        data() {
            return {
                cid:'',
                sid:'',
                prveStatus:'',
                showIndex:null,
                isShowNumImg:0,
                iscreatebarcode:JSON.parse(localStorage.getItem('shop')).iscreatebarcode,//是否设置自动生成条码
                loading:false,
                submitLoading:false,
                isShowUpload:true,
                actionImgUrl:this.ACTIONIMGURL,
                contentName:'',
                sendData:{
                    name:'',
                    goodscode: '',//货号
                    cprice: null,
                    lprice: null,
                    pprice:null,
                    sex:'2',
                    colorList:this.$store.state.AddCommodity.colourGroup,
                    sizeList:this.$store.state.AddCommodity.sizeGroup,
                    warning:1,
                },
                SupplierList:[],//供应商列表
                SupplierName:'',
                imgName: '',
                visible: false,
                uploadList: [],
                /*分类*/
                goodsClassify:[],
                typeItmes:[],
                isClickNum:0,
                addNames:'',//新增的类名字
                typeGoodsId:null,//父及id
                typeGoodsName:null,//父及名字
                selZidsName:null,//子级名字
                selZids:null,//子级id
                isShowRight:false,
                showTypeTrue:null,
                SupplierName:'',
                isroule:true,//是否有权限
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            //this.prveStatus = this.$route.query.status
            this.$store.state.AddCommodity.colourGroup=[]
            this.$store.state.AddCommodity.sizeGroup=[]
            this.getTypeList()
            this.getSupplierList()
            var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
            if(!PermisCode.includes('94')){
                this.isroule=false
            }
        },
        mounted () {
            this.uploadList =  this.$refs.upload.fileList;

        },
        watch: {
            '$store.state.AddCommodity.colourGroup':function(val) {
                 this.sendData.colorList = val;
            },
            '$store.state.AddCommodity.sizeGroup':function(val) {
                this.sendData.sizeList = val;
            },
            'sendData.cprice':function(val) {
                this.$store.state.AddCommodity.cprice=val
            },

            'SupplierName': {
                deep: true,
                handler: function (newVal, oldVal) {
                     this.getSupplierList()
                }
            },

        },
        methods: {

            /****
             * 分类列表
             * ****/
            getTypeList(){
                this.$Api.getTypeList({
                    cid: this.cid,
                    sid: this.sid,
                    mark: 0
                }).then(res => {
                    if(res.code==200){
                        if(res.data!=''){
                            this.goodsClassify = res.data
                        }else {
                            this.goodsClassify=[
                                {
                                    cid: null,
                                    id: null,
                                    mark:null,
                                    name: null,
                                    sid:null,
                                    type_itmes: [{cid: null,
                                        id:  null,
                                        name:  null,
                                        sid:  null,
                                        typeGoodsId: null,
                                        typeGoodsName:  null}]
                                }

                            ]
                        }

                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
             },

            /*****
             * 确定父级
             * id***/
            selFid(item,index){
                this.isClickNum=index
                this.typeGoodsName = item.name
                this.showTypeTrue=item.name
                this.typeGoodsId = item.id,
                this.selZids=null
                this.selZidsName=null
                this.isShowRight=false
            },

             /***
              * 确定子级id
              * **/
            selZid(m){
                 if(this.typeGoodsName==null||this.typeGoodsName=='' || this.typeGoodsName=='默认'){
                     this.$Message.warning('你还没选择上级呢');
                     return;
                 }
                 this.selZidsName=m.name
                 this.showTypeTrue=this.typeGoodsName+' > '+m.name
                 this.selZids = m.id
                 this.isShowRight=true
                 this.$store.state.AddCommodity.allDrawer = false;
            },

            /***
             * 不选分类
             * ***/
            defaultNull(){
                this.typeGoodsName = '默认' 
                this.selZidsName=''
                this.showTypeTrue='默认'
                this.typeGoodsId=null,//大分类
                 this.selZids=null,//小分类
                this.isShowRight = false
                this.$store.state.AddCommodity.allDrawer = false;

            },
            /***
             * 添加分类
             * ***/
            addTypeItem(n){

                var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
                if(!PermisCode.includes('121')){
                    this.$Message.info('暂无权限');
                    return
                }

                this.$Modal.confirm({
                    title: '添加分类名称',
                    closable: true,
                    loading: true,
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: this.value,
                                autofocus: true,
                                placeholder: '分类名称'
                            },
                            on: {
                                input: (val) => {
                                    this.addNames = val;
                                }
                            }
                        })
                    },
                    onOk: ()=> {
                        if(this.addNames==''){
                            this.$Message.warning('请填写分类名称');
                            return
                        }
                        if(n==0){//添加父类
                            this.sendfatherFn()
                        }else {//添加子类
                            this.sendChildrenFn()
                        }
                    }
                })
            },

            /***
             * 添加父分组
             * ***/
            sendfatherFn(){
                this.$Api.addType({
                    cid: this.cid,
                    sid: this.sid,
                    name: this.addNames
                }).then(res => {
                    if(res.code==200){
                        this.$Message.success('添加成功');
                        this.$Modal.remove()
                        this.getTypeList()
                        this.isClickNum=this.goodsClassify.length
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },

            /****
             * 添加子分组
             * *****/
            sendChildrenFn(){
                this.$Api.addItme({
                    cid: this.cid,
                    sid: this.sid,
                    name: this.addNames,
                    typeGoodsId: this.typeGoodsId
                }).then(res => {
                    if(res.code==200){
                        this.$Message.success('添加成功');
                        this.$Modal.remove()
                        this.getTypeList()
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },

            /****
             * 删除分类
             * *****/
            delTypeItem(id,n){
                var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
                if(!PermisCode.includes('121')){
                    this.$Message.info('暂无权限');
                    return
                }
                if(n==0){ //0删除父类  1删除子类
                    this.$Api.delType({
                        id: id
                    }).then( res => {
                        if(res.code==200){
                            this.$Message.success('删除成功');
                            this.getTypeList()
                        }else {
                            this.$Message.warning(res.msg);
                        }
                    }).catch((err)=>{
                        this.$Message.warning(err.msg);
                    });
                }else {
                    this.$Api.delItme({
                        id: id
                    }).then( res => {
                        if(res.code==200){
                            this.$Message.success('删除成功');
                            this.getTypeList()
                        }else {
                            this.$Message.warning(res.msg);
                        }
                    }).catch((err)=>{
                        this.$Message.warning(err.msg);
                    });;
                }

            },
            /****
             * 添加颜色窗口
             * *****/
            openDrawer(n,title){

                var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
                if(!PermisCode.includes('121')&& n==3){
                    this.$Message.warning('暂无权限');
                    return
                }

                if(this.SupplierList.length==0){
                    this.$Message.warning('请先添加供应商'); return
                }
                var  colourGroup = this.$store.state.AddCommodity.colourGroup
                var  sizeGroup = this.$store.state.AddCommodity.sizeGroup

                if(n==5||n==6){
                    if( colourGroup.length==0){
                        colourGroup.push({
                            id: 0,
                            name: '均色'
                        })
                    }
                    if( sizeGroup.length==0){
                        sizeGroup.push({
                            id: 0,
                            name: '均码'
                        })
                    }
                    if( this.sendData.cprice==null){
                        this.$Message.warning('请先填写采购价'); return
                    }
                }
                this.$store.state.AddCommodity.allDrawer=true
                this.showIndex=n
                this.contentName=title
                var result=0;
                if(this.$store.state.AddCommodity.goodsItems!=='' && n==5 ){
                    this.$store.state.AddCommodity.goodsItems.forEach((item,index)=>{
                        item.chilren.forEach((key,val)=>{
                            result+=key.moudel
                        })
                    })
                }
                this.$store.state.AddCommodity.count=result
                this.$store.state.AddCommodity.allMoney=this.$store.state.AddCommodity.count*this.$store.state.AddCommodity.cprice
                this.$store.state.AddCommodity.money=this.$store.state.AddCommodity.count*this.$store.state.AddCommodity.cprice
            },

            //供应商列表
            getSupplierList(){
                this.$Api.getSupplierList({
                    cid: this.cid,
                    sid: this.sid,
                    name:this.SupplierName,
                    page: 1,
                    rows: 100,
                    isdel: 1
                }).then(res => {
                    if(res.code==200){
                        if(res.data!=''){
                            this.SupplierList = res.data
                            this.$store.state.AddCommodity.SupplierName=res.data[0]
                        }else {
                            this.$store.state.AddCommodity.SupplierName.name=''
                        }
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            /***
             * 选择供应商
             * */
            selectSupOK(data){
                this.$store.state.AddCommodity.SupplierName=data
                this.$store.state.AddCommodity.childerDrawer=false;
            },

             /*查看大图*/
            handleView (data) {
                this.isShowNumImg=data
                this.visible = true;
            },
            /*删除上传*/

            handleRemove (file) {
                const fileList = this.$refs.upload.fileList;
                this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
            },
            //文件上传之前时的钩子，
            beforeUpload(){
                const check = this.uploadList.length < 8;
                if (!check) {
                    this.$Notice.warning({
                        title: '图片最多上传8张'
                    });
                }
                return check;
            },
            //文件上传成功时的钩子，返回字段为 response, file, fileList
            handleSuccess (res, file) {
                const fileList = this.$refs.upload.fileList;
                 if(res.code==200){
                     file.status=file.status
                     file.url=res.data.src
                     file.name=file.name
                     file.percentage=file.percentage
                     file.showProgress=file.showProgress
                 }else {
                     this.$Message.warning('上传失败');
                 }
            },

            //文件格式验证失败时的钩子，返回字段为 file, fileList
            handleFormatError (file,fileList) {
               this.$Message.warning('文件格式不正确');
            },
            handleMaxSize (file,fileList) {
                this.$Message.warning('文件不能超过5M');
            },
            /*添加商品*/
            addGoods(){
                if(this.sendData.name==''){
                    this.sendData.name='无名商品'
                }
                if(this.sendData.goodscode==''){
                    this.$Message.warning('商品货号为必填项');
                    return
                }
                if(this.sendData.cprice==null){
                    this.sendData.cprice=0
                }
                if(this.sendData.lprice==null && this.sendData.pprice==null){
                    this.$Message.warning('零售价和批发价至少填一个');
                    return
                }
                if(this.sendData.lprice==null && this.sendData.pprice!=null){
                    this.sendData.lprice=this.sendData.pprice
                }
                if(this.sendData.lprice!=null && this.sendData.pprice==null){
                     this.sendData.pprice=this.sendData.lprice
                }

                var gcolor=''
                var gsize=''
                this.sendData.colorList.forEach((item,index)=>{
                    gcolor+=item.id+','
                })
                this.sendData.sizeList.forEach((item,index)=>{
                    gsize+=item.id+','
                })

                //如果颜色、规格都不选，默认均码
                if(gcolor==''){   gcolor=0 }
                if(gsize==''){ gsize=0 }
                if(this.$store.state.AddCommodity.barCodeSetting!=''){
                    var barCodeSettings=[]
                    this.$store.state.AddCommodity.barCodeSetting.forEach( (item, index)=> {
                    if(item.dataCode){
                        barCodeSettings.push({
                            colorid: item.colorid,
                            sizeid: item.sizeid,
                            barcode: "c"+this.sid+"|"+item.dataCode
                        })
                      }
                    })
                }

                var goodsItems=[];
                let total = 0;
                this.$store.state.AddCommodity.goodsItems.forEach((item,index)=>{
                    item.chilren.forEach((key,val)=>{
                        goodsItems.push({
                            colorid:key.colorid,
                            sizeid:key.sizeid,
                            quantity:key.moudel,
                            cprice:this.sendData.cprice
                        })
                    })
                })

                var imgGroupSlep=''
                this.uploadList.forEach((item , index)=>{
                    imgGroupSlep+=item.url+','
                })
                let goodsStock = JSON.parse(JSON.stringify(goodsItems));
                goodsStock = goodsStock.filter(val=>{
                    total+=val.quantity;
                    return val.quantity != 0;
                })
                //设置库存
                var data={
                     cid:this.cid,
                     sid:this.sid,
                     name:this.sendData.name,
                     goodsimg:imgGroupSlep,
                     goodscode: this.sendData.goodscode,
                     cprice: this.sendData.cprice,
                     lprice: this.sendData.lprice,
                     pprice: this.sendData.pprice,
                     sex: this.sendData.sex,
                     typeGoodsId: this.typeGoodsId,//大分类
                     typeItmeId: this.selZids,//小分类
                     warning:this.sendData.warning || 1,//预警
                     gcolor: gcolor,
                     gsize: gsize,
                     iscreatebarcode: this.iscreatebarcode,
                     barcodes:JSON.stringify( barCodeSettings ),//条码设置
                     adminid: JSON.parse(localStorage.getItem("adminUser")).id,
                     bank: this.$store.state.AddCommodity.bank,
                     bankid: this.$store.state.AddCommodity.bankid,
                     money: this.$store.state.AddCommodity.money,
                     paymoney:  this.$store.state.AddCommodity.paymoney,
                     nomoney: this.$store.state.AddCommodity.money-this.$store.state.AddCommodity.paymoney,
                     supplierid: this.$store.state.AddCommodity.SupplierName.id, //供应商id
                     suppliername: this.$store.state.AddCommodity.SupplierName.name,//供应商名字
                     goodsItems:JSON.stringify( goodsStock ),
                     status: 2,
                     remark:'',
                     total: total,
                 }
                 var data2={
                     cid:this.cid,
                     sid:this.sid,
                     name:this.sendData.name,
                     goodsimg:imgGroupSlep,
                     goodscode: this.sendData.goodscode,
                     cprice: this.sendData.cprice,
                     lprice: this.sendData.lprice,
                     pprice: this.sendData.pprice,
                     sex: this.sendData.sex,
                     typeGoodsId: this.typeGoodsId,//大分类
                     typeItmeId: this.selZids,//小分类
                     warning:this.sendData.warning || 1,//预警
                     gcolor: gcolor,
                     gsize: gsize,
                     iscreatebarcode: this.iscreatebarcode,
                     barcodes:JSON.stringify( barCodeSettings ),//条码设置
                     adminid: JSON.parse(localStorage.getItem("adminUser")).id,
                     status: 2,
                     remark:'',
                 }
                this.submitLoading=true
                if(this.$store.state.AddCommodity.total!=0){//设置库存掉的接口
                    this.$Api.addGoodsAndStock(data).then(res => {
                        if(res.code==200){
                            this.$Message.success('添加成功');
                            this.$store.state.AddCommodity.colourGroup=[]
                            this.$store.state.AddCommodity.sizeGroup=[]
                            this.$store.state.AddCommodity.SupplierName={}
                            this.$store.state.AddCommodity.barCodeSetting=''
                            this.$store.state.AddCommodity.total=0
                            this.$store.state.AddCommodity.goodsItems=[];
                            this.$store.state.AddCommodity.cprice = 0;

                            if(this.sendData.pprice<this.sendData.cprice||this.sendData.lprice<this.sendData.cprice){
                                this.$Message.warning({
                                    content:'亲···，批发价或零售价低于采购价！',
                                    duration: 3
                                });

                            }
                            this.$router.push({
                                path:'/goodslist'
                            })
                        }else {
                            this.$Message.warning(res.msg);
                            this.submitLoading=false
                        }
                    }).catch( (err)=> {
                        this.submitLoading=false
                    })
                }else {
                    this.$Api.addGoods(data2).then(res => {
                        if(res.code==200){
                            this.$Message.success('添加成功');
                            this.$store.state.AddCommodity.colourGroup=[]
                            this.$store.state.AddCommodity.sizeGroup=[]
                            this.$store.state.AddCommodity.barCodeSetting=''
                            this.$store.state.AddCommodity.total=0;
                            this.$store.state.AddCommodity.cprice = 0;
                            if((this.sendData.pprice<this.sendData.cprice)||(this.sendData.lprice<this.sendData.cprice)){
                                this.$Message.warning({
                                    content:'亲···，批发价或零售价低于采购价！',
                                    duration: 3
                                });
                            }
                            this.$router.push({
                                path:'/goodslist'
                            })


                        }else {
                            this.$Message.warning(res.msg);
                            this.submitLoading=false
                        }
                    }).catch( (err)=> {
                        this.submitLoading=false;
                        this.$Message.warning(err.msg);
                    })
                }
            },
        }
    };
</script>

<style lang="scss" scoped>
    .form-title{
        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
.edit-input{
    width: 220px;
}
    .demo-upload-list{
        display: inline-block;
        width: 100px;
        height: 100px;
        text-align: center;
        line-height: 100px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }

    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
    .fatherTitle{
       background: #f9f9f9;
        height: 60px;
        line-height: 60px;
    }
 .select-fatherTitle{
     height: 100%;
     padding: 10px;

     background: #f9f9f9;
     cursor: pointer;
     .active{
         background: #ffffff;
         color: #739aff;

     }
 }
    .aside-childer{
        background: #ffffff;
        height: 100%;
        div{
            height: 60px;
            line-height: 60px;
            padding-left: 10px;
        }
        div:hover{
            color: #739aff;
            background:#fbfbfb;
        }

    }
    .delBtn{
        display: none;
        position: absolute;
        top: 17px;
    }
    .fatherTitle:hover{
        .delBtn{
            display: inline;
        }
    }
    .aside-childer div:hover{
        .delBtn{
            display: inline;

        }
    }

</style>